// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"8223411d","172":"6086ae0e","179":"c7afb4c3","245":"57f12f38","398":"26095da0","908":"19d341b6","916":"7adf347c"}[chunkId] + ".chunk.js";
};